<template>
  <a-modal :title="$t('AccountInfo.BalanceRecharge.rechargeTitle')"
           :visible="visible"
           :width="400"
           :ok-text="$t('AccountInfo.BalanceRecharge.rechargeButton')"
           centered
           @ok="handleOk"
           @cancel="handleCancel">
    <a-form ref="form"
            :model="formState"
            :rules="rules">
      <a-form-item :label="$t('AccountInfo.BalanceRecharge.amountLabel')"
                   name="amount"
                   :colon=false
                   :rules="[{ required: true, message: $t('AccountInfo.BalanceRecharge.amountError') }]">
        <a-input-number v-model:value="formState.amount"
                        :step="0.01"
                        :min="0"
                        :placeholder="$t('AccountInfo.BalanceRecharge.amountPlaceholder')"
                        style="width: 100%;" />
      </a-form-item>
      <a-form-item :label="$t('AccountInfo.BalanceRecharge.paymentMethodLabel')"
                   name="route"
                   :colon=false
                   :rules="[{ required: true, message: $t('AccountInfo.BalanceRecharge.paymentMethodError') }]">
        <a-radio-group v-model:value="formState.route">
          <a-radio :value="0">{{ $t('AccountInfo.BalanceRecharge.alipay') }}</a-radio>
          <a-radio :value="1">{{ $t('AccountInfo.BalanceRecharge.wechat') }}</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  visible: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['close', 'submit'])
const form = ref<any>(null)
const { t } = useI18n()
const formState = ref({
  amount: '',
  route: ''
})

// 定义验证规则
const rules = computed(() => ({
  amount: [{ required: true, message: t('AccountInfo.BalanceRecharge.amountError'), trigger: 'blur' }],
  route: [{ required: true, message: t('AccountInfo.BalanceRecharge.paymentMethodError'), trigger: 'change' }],
}))

const handleSubmit = () => {
  form.value?.validate().then(() => {
    emit('submit', { amount: formState.value.amount, route: Number(formState.value.route) })
  }).catch((errorInfo: string) => {
    console.error('Validate Failed:', errorInfo)
  })
}

const handleOk = () => {
  handleSubmit()
}

const handleCancel = () => {
  emit('close')
}
</script>


<style scoped lang="less"></style>
